<div class="edit-posting-form">
  <header class="mb-3 mb-md-4">
    <h3 class="content-card-title">{{tiresFormTranslationObj.tireForm.textTires}}</h3>
    <div class="content-card-subtitle">
      <p>
        {{tiresFormTranslationObj.tireForm.textEnterInfo}}
      </p>

      @if (isNewPosting && !isSelectionValid) {
        <div class="text-danger fw-bold tireCertificationWarning">
          {{tiresFormTranslationObj.tireDescriptionForm.tireCertificationWarning}}
        </div>
      }

      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input excludes__input"
          id="certify-tire-info"
          (change)="maybeCertify($event)"
          [checked]="tireCheckboxCertified"
          [value]="tireCheckboxCertified"
          />
        <label class="custom-control-label excludes__label" for="certify-tire-info">
          {{tiresFormTranslationObj.tireForm.textCheckingBox}}
        </label>
      </div>
    </div>
  </header>
  <section class="p-3 p-md-0">
    @if (!tireCheckboxCertified) {
      <app-table [displayStyle]="tireTableStyle$ | async">
        <table cdk-table [multiTemplateDataRows]="true" [dataSource]="tiresFormService" [trackBy]="trackByLocation">
          <caption class="visually-hidden">{{tiresFormTranslationObj.tireForm.textTireInformation}}</caption>
          <ng-container cdkColumnDef="spacer" class="left-column">
            <th cdk-header-cell id="spacer-column-header" *cdkHeaderCellDef></th>
            <td cdk-cell *cdkCellDef="let tire"><!-- intentionally blank--></td>
          </ng-container>
          <ng-container cdkColumnDef="tire-toggle" class="left-column">
            <th cdk-header-cell id="tire-toggle-column-header" *cdkHeaderCellDef>{{tiresFormTranslationObj.tireForm.textWheel}}</th>
            <td cdk-cell *cdkCellDef="let tire">
              <button
                class="btn btn-link expand-btn"
                [attr.aria-label]="(!tire.expanded ? tiresFormTranslationObj.tireForm.ariaLabelExpand : tiresFormTranslationObj.tireForm.ariaLabelCollapse ) + tire.locationName + tiresFormTranslationObj.tireForm.ariaLabelDrawer"
                [attr.aria-expanded]="tire.expanded"
                (click)="toggleDrawer(tire.location)"
                type="button"
                [attr.data-track-name]="analyticsLocationName(tire.location)"
                >
                <i
                  aria-hidden="true"
                  class="allycon-glyph-chevron-right expand-toggle me-2"
                  [ngClass]="{ 'expand-toggle--expanded': tire.expanded }"
                ></i>
                {{tiresFormTranslationObj.tireForm[tire.location]}}
              </button>
            </td>
          </ng-container>
          <ng-container cdkColumnDef="manufacturer" class="left-column">
            <th cdk-header-cell id="manufacturer-column-header" *cdkHeaderCellDef>{{tiresFormTranslationObj.tireForm.textManufacturer}}</th>
            <td cdk-cell *cdkCellDef="let tire">{{ tire.manufacturer }}</td>
          </ng-container>
          <ng-container cdkColumnDef="size" class="left-column">
            <th cdk-header-cell id="tire-size-column-header" *cdkHeaderCellDef>{{tiresFormTranslationObj.tireForm.textTireSize}}</th>
            <td cdk-cell *cdkCellDef="let tire">{{ tire.size }}</td>
          </ng-container>
          <ng-container cdkColumnDef="tread" class="left-column">
            <th cdk-header-cell id="tread-depth-column-header" *cdkHeaderCellDef>{{tiresFormTranslationObj.tireForm.textTreadDepth}}</th>
            <td cdk-cell *cdkCellDef="let tire">{{ tire.tread }}</td>
          </ng-container>
          <ng-container cdkColumnDef="comments" class="left-column">
            <th cdk-header-cell id="comments-column-header" *cdkHeaderCellDef>{{tiresFormTranslationObj.tireForm.textDescription}}</th>
            <td cdk-cell *cdkCellDef="let tire">{{ tire.comments }}</td>
          </ng-container>
          <ng-container cdkColumnDef="cost" class="left-column">
            <th cdk-header-cell id="cost-column-header" *cdkHeaderCellDef>{{tiresFormTranslationObj.tireForm.textCost}}</th>
            <td cdk-cell *cdkCellDef="let tire">
              @if (tire.damageCost) {
                {{ formatCurrency(tire.damageCost) }}
              }
            </td>
          </ng-container>
          <ng-container cdkColumnDef="image" class="left-column">
            <th cdk-header-cell id="image-column-header" *cdkHeaderCellDef>{{tiresFormTranslationObj.tireForm.textImage}}</th>
            <td cdk-cell *cdkCellDef="let tire">
              @if (tire.tireImages?.length) {
                <img
                  class="image-checkmark-circle"
                  src="../../../../../ui/assets/img/checkmark-circle.png"
                  alt="{{checked}}"
                  />
              }
            </td>
          </ng-container>
          <ng-container cdkColumnDef="tireForm">
            <td cdk-cell *cdkCellDef="let tire" [attr.colspan]="7">
              @if (tire.expanded) {
                <div class="pt-3 pb-4">
                  <app-tire-description-form
                    [tire]="tire"
                    [currentVehicleVinNumber]="vehicleVINNumber"
                    (cancel)="toggleDrawer(tire.location)"
                    (update)="onUpdateForm($event)"
                  ></app-tire-description-form>
                </div>
              }
            </td>
          </ng-container>
          <tr
            cdk-header-row
            class="table-row"
            *cdkHeaderRowDef="['spacer', 'tire-toggle', 'manufacturer', 'size', 'tread', 'comments', 'cost', 'image']"
          ></tr>
          <tr
            cdk-row
            class="table-row"
            *cdkRowDef="let row; columns: ['spacer', 'tire-toggle', 'manufacturer', 'size', 'tread', 'comments', 'cost', 'image']"
          ></tr>
          <tr
            cdk-row
            *cdkRowDef="let tire; columns: ['spacer', 'tireForm']"
            class="tire-form-row"
            [ngClass]="{ 'tire-form-row--visible': tire.expanded, 'table-drawer': tire.expanded }"
            [attr.aria-hidden]="!tire.expanded"
          ></tr>
        </table>
        @for (tire of tiresFormService.connect() | async; track trackByLocation($index, tire)) {
          <app-table-card>
            <app-table-card-header>
              <button
                class="btn btn-link expand-btn"
                [attr.aria-label]="(!tire.expanded ? 'Expand ' : 'Collapse ') + tire.locationName + ' drawer.'"
                [attr.aria-expanded]="tire.expanded"
                (click)="toggleDrawer(tire.location)"
                [attr.data-track-name]="analyticsLocationName(tire.location)"
                type="button"
                >
                <i
                  aria-hidden="true"
                  class="allycon-glyph-chevron-right expand-toggle"
                  [ngClass]="{ 'expand-toggle--expanded': tire.expanded }"
                ></i>
                {{ tiresFormTranslationObj.tireForm[tire.location] }}
              </button>
            </app-table-card-header>
            <app-table-card-body>
              <div>
                <dl class="tire-info-list">
                  <div class="row">
                    <div class="col-6">
                      <dt>{{tiresFormTranslationObj.tireForm.textManufacturer}}:</dt>
                      <dd>
                        <span>{{ tire.manufacturer }}</span>
                      </dd>
                    </div>
                    <div class="col-6">
                      <dt>{{tiresFormTranslationObj.tireForm.textTireSize}}:</dt>
                      <dd>
                        <span>{{ tire.size }}</span>
                      </dd>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <dt>{{tiresFormTranslationObj.tireForm.textTreadDepth}}:</dt>
                      <dd>
                        <span>{{ tire.tread }}</span>
                      </dd>
                    </div>
                    <div class="col-6">
                      <dt>{{tiresFormTranslationObj.tireForm.textCost}}:</dt>
                      <dd>
                        <span>
                          @if (tire.damageCost) {
                            {{ tire.damageCost | currency: '':'symbol' }}
                          }
                        </span>
                      </dd>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <dt>{{tiresFormTranslationObj.tireForm.textDescription}}:</dt>
                      <dd>
                        <span>{{ tire.comments }}</span>
                      </dd>
                    </div>
                    <div class="col-6">
                      <dt>{{tiresFormTranslationObj.tireForm.textImage}}:</dt>
                      <dd>
                        @if (tire.tireImages?.length) {
                          <img
                            class="image-checkmark-circle mt-2"
                            src="../../../../../ui/assets/img/checkmark-circle.png"
                            alt="{{checked}}"
                            />
                        }
                      </dd>
                    </div>
                  </div>
                </dl>
              </div>
              @if (tire.expanded) {
                <section class="table-drawer pt-2">
                  <app-tire-description-form
                    [tire]="tire"
                    [currentVehicleVinNumber]="vehicleVINNumber"
                    (cancel)="toggleDrawer(tire.location)"
                    (update)="onUpdateForm($event)"
                  ></app-tire-description-form>
                </section>
              }
            </app-table-card-body>
          </app-table-card>
        }
      </app-table>
    }
  </section>
</div>
